
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lands/[color]",
      function () {
        return require("private-next-pages/lands/[color]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lands/[color]"])
      });
    }
  